import { createFileRoute } from "@tanstack/react-router";
import CustomerDashboard from "@/pages/customer/CustomerDashboard";
import { pageHead } from "@/lib/routeHead";

export const Route = createFileRoute("/my-account/")({
  head: () => { const h = pageHead({ title: 'Rex & Sons RVs', description: 'Rex & Sons RVs — family-owned RV dealer in Castle Hayne, NC since 1997. Sales, service, parts and rentals.', path: '/my-account' }); h.meta.push({ name: "robots", content: "noindex, follow" }); return h; },
  component: CustomerDashboard,
});
